import axios from "axios";
import twitJs from "./../lib/twitter";
import html2canvas from "html2canvas";
import Logger from "./../lib/logger";
import { makeCancellable } from "vuex-cancellable-actions";

export default {
  namespaced: true,
  state: {
    /** 設定ファイル */
    snsConfig: null,
    type: null,
    /** LINE投稿テキスト */
    lineText: null,
    /** Twitter情報 */
    oauthToken: null,
    oauthTokenSecret: null,
    oauthVerifier: null,
    accessToken: null,
    accessTokenSecret: null,
    /** カメラの選択情報 */
    postCamera: "live",
    /** Twitter投稿画面表示/非表示情報 */
    showTwitterCheck: false,
    /** Twitter投稿中表示 */
    twitterLoading: false,
    printCurrentPicture: null,
    printNormallyPicture: null,
  },
  mutations: {
    /** 設定の初期化 */
    setSnsConfig(state, config) {
      Logger.debug("[sns]mut - setSnsConfig()");
      Logger.dir(config);
      state.snsConfig = config;
    },
    /** 投稿タイプの設定 */
    setType(state, type) {
      Logger.debug("[sns]mut - setType()");
      Logger.dir(type);
      state.type = type;
    },
    /** 投稿テキストの設定 */
    setLineText(state, lineText) {
      Logger.debug("[sns]mut - setLineText()");
      Logger.dir(lineText);
      state.lineText = lineText;
    },
    /** oauth_tokenを設定 */
    setOauthToken(state, oauthToken) {
      Logger.debug("[sns]mut - setOauthToken()");
      Logger.dir(oauthToken);
      state.oauthToken = oauthToken;
    },
    /** oauth_token_secretを設定 */
    setOauthTokenSecret(state, oauthTokenSecret) {
      // セキュリティを考慮しトークンのシークレットをログ出力させない
      state.oauthTokenSecret = oauthTokenSecret;
    },
    /** oauth_verifierを設定 */
    setOauthVerifier(state, oauthVerifier) {
      Logger.debug("[sns]mut - setOauthVerifier()");
      Logger.dir(oauthVerifier);
      state.oauthVerifier = oauthVerifier;
    },
    /** access_tokenを設定 */
    setAccessToken(state, accessToken) {
      Logger.debug("[sns]mut - setAccessToken()");
      // セキュリティを考慮しトークンを出力させない
      state.accessToken = accessToken;
    },
    /** access_token_secretを設定 */
    setAccessTokenSecret(state, accessTokenSecret) {
      Logger.debug("[sns]mut - setAccessTokenSecret()");
      // セキュリティを考慮しトークンのシークレットを出力させない
      state.accessTokenSecret = accessTokenSecret;
    },
    /** 投稿するカメラ(現在か平常)を設定 */
    setPostCamera(state, postCamera) {
      Logger.debug("[sns]mut - setPostCamera()");
      state.postCamera = postCamera;
    },
    /** 投稿画面の表示情報を設定 */
    setShowTwitterCheck(state, showTwitterCheck) {
      Logger.debug("[sns]mut - setShowTwitterCheck()");
      state.showTwitterCheck = showTwitterCheck;
    },
    /** 投稿画面の表示情報を設定 */
    setTwitterLoading(state, twitterLoading) {
      Logger.debug("[sns]mut - setTwitterLoading()");
      state.twitterLoading = twitterLoading;
    },
    setPrintCurrentPicture(state, printCurrentPicture) {
      Logger.debug("[sns]mut - setPrintCurrentPicture()");
      state.printCurrentPicture = printCurrentPicture;
    },
    setPrintNormallyPicture(state, printNormallyPicture) {
      Logger.debug("[sns]mut - setPrintNormallyPicture()");
      state.printNormallyPicture = printNormallyPicture;
    },
  },
  actions: makeCancellable({
    /**
     * FaceBook投稿
     */
    async postFacebook({ state }, { url }) {
      Logger.debug("[sns]act - postFacebook(" + url + ")");
      let config = state.snsConfig.facebook;

      let shareUrl = encodeURIComponent(url);
      let facebookUrl = config.shareUrl + shareUrl;

      Logger.debug("[sns]facebookUrl = " + facebookUrl);
      window.open(facebookUrl, "_blank");
    },
    /**
     * LINE投稿
     */
    async postLine({ state, commit }, { lat, lon, mode }) {
      Logger.debug("[sns]act - postLine()");
      let type = state.type;
      let config = state.snsConfig.line;
      let url = location.href;
      let currentPath = location.pathname;
      let currentQuery = location.search;
      let obsPath = currentPath.split("/");
      obsPath = obsPath[obsPath.length - 1];
      let obsQuery = currentQuery
        .replace(/(clat=)\d+(?:\.\d+)?/, "clat=" + lat)
        .replace(/(clon=)\d+(?:\.\d+)?/, "clon=" + lon);
      history.replaceState(null, "", encodeURIComponent(obsPath + obsQuery));

      let shareUrl = encodeURIComponent(url);
      if (state.lineText != null) {
        let lineText = encodeURIComponent(state.lineText);
        let lineUrl = null;
        if (mode == "pc") {
          lineUrl = config.shareUrlPc + shareUrl + config.pcText + lineText;
        } else if (type === "cctv" || type === "scam") {
          lineUrl = config.shareUrl + lineText;
        } else {
          lineUrl = config.shareUrl + lineText + shareUrl;
        }
        Logger.debug("[sns]lineUrl = " + lineUrl);
        window.open(lineUrl, "_blank");

        history.replaceState(null, "", currentPath + currentQuery);
        commit("setLineText", null);
      } else {
        window.alert("投稿テキストの取得が失敗したため投稿できません。");
      }
    },
    /**
     * LINE投稿テキスト生成(観測所)
     */
    async textLineObs({ state, commit }, { view, obsNm, rvrNm, rsysNm }) {
      Logger.debug("[sns]act - textLineObs()");
      let config = state.snsConfig.line;

      let shareText = config.obsFrame;
      if (rsysNm == null) {
        shareText = shareText
          .replace("*VIEW*", view != null ? view : "")
          .replace("*TMNAME*", obsNm != null ? obsNm : "")
          .replace("*RIVER*", rvrNm != null ? rvrNm : "")
          .replace("*RSYS*水系", "");
      } else {
        shareText = shareText
          .replace("*VIEW*", view != null ? view : "")
          .replace("*TMNAME*", obsNm != null ? obsNm : "")
          .replace("*RIVER*", rvrNm != null ? rvrNm : "")
          .replace("*RSYS*", rsysNm);
      }

      commit("setLineText", shareText);
    },
    /**
     * LINE投稿テキスト生成(レーダ)
     */
    async textLineRadar({ state, commit }, { area }) {
      Logger.debug("[sns]act - textLineRadar(" + area + ")");
      let config = state.snsConfig.line;
      let shareText = config.radarFrame;
      shareText = shareText.replace("*AREA*", area);

      commit("setLineText", shareText);
    },
    /**
     * LINE投稿テキスト生成(カメラ)
     */
    async textLineCam(
      { state, commit },
      { view, camNm, rvrNm, rsysNm, camUrl, mode }
    ) {
      Logger.debug("[sns]act - postLineCam()");
      let config = state.snsConfig.line;
      let textObs = config.obsFrame;
      if (rsysNm == null) {
        textObs = textObs
          .replace("*VIEW*", view != null ? view : "")
          .replace("*TMNAME*", camNm != null ? camNm : "")
          .replace("*RIVER*", rvrNm != null ? rvrNm : "")
          .replace("*RSYS*水系", "");
      } else {
        textObs = textObs
          .replace("*VIEW*", view != null ? view : "")
          .replace("*TMNAME*", camNm != null ? camNm : "")
          .replace("*RIVER*", rvrNm != null ? rvrNm : "")
          .replace("*RSYS*", rsysNm);
      }
      let textCam = config.camFrame;
      textCam = textCam.replace("*CAMURL*", camUrl);

      let shareText = null;
      if (mode == "pc") {
        shareText = textObs + textCam;
      } else {
        let url = location.href;
        shareText = textObs + url + textCam;
      }

      commit("setLineText", shareText);
    },
    /**
     * 選択されているカメラ情報を取得
     */
    async getPostCamera({ commit }, { camera }) {
      Logger.debug("[sns]act - getPostCamera()");
      commit("setPostCamera", camera);
    },
    /**
     * Twitterリクエストトークンを取得
     */
    async getRequestToken({ state }, { subWin }) {
      Logger.debug("[sns]act - getRequestToken()");
      let config = state.snsConfig.twitter;
      let errMes = config.errorMessage;
      let reqUrl =
        process.env.NODE_ENV === "development"
          ? "/sns/twitter/request?from=web"
          : "/api/sns/twitter/request?from=web";
      axios
        .post(reqUrl, {
          headers: {
            "Access-Control-Allow-Origin": "*",
          },
        })
        .then((res) => {
          if (res.data.message != "Faild.") {
            twitJs.setTwitterRequest({
              reqToken: res.data.oauth_token,
              reqTokenSecret: res.data.oauth_token_secret,
            });
            let url = config.redirectUrl + res.data.oauth_token;
            subWin.location.href = url;
          } else {
            window.alert(errMes.request);
          }
        })
        .catch((error) => {
          Logger.debug("[sns]act - getRequestToken() error: " + error);
          window.alert(errMes.request);
        });
    },
    /**
     * Twitterアクセストークンを取得
     */
    async getAccessToken({ state, commit }) {
      Logger.debug("[sns]act - getAccessToken()");
      let errMes = state.snsConfig.twitter.errorMessage;
      let postUrl = null;
      if (process.env.NODE_ENV === "development") {
        postUrl =
          "/sns/twitter/access?from=web&oauthVerifier=" +
          state.oauthVerifier +
          "&oauthToken=" +
          state.oauthToken;
      } else {
        postUrl =
          "/api/sns/twitter/access?from=web&oauthVerifier=" +
          state.oauthVerifier +
          "&oauthToken=" +
          state.oauthToken;
      }

      axios
        .post(postUrl, {
          headers: {
            "Access-Control-Allow-Origin": "*",
          },
          data: {
            oauthTokenSecret: twitJs.getTwitterRequest().reqTokenSecret,
          },  
        })
        .then((res) => {
          if (res.data.message != "Faild.") {
            twitJs.setTwitterAccess({
              acsToken: res.data.oauth_token,
              acsTokenSecret: res.data.oauth_token_secret,
            });
            commit("setAccessToken", res.data.oauth_token);
            commit("setAccessTokenSecret", res.data.oauth_token_secret);
          } else {
            window.alert(errMes.access);
            window.close();
          }
        })
        .catch((error) => {
          Logger.debug("[sns]act - error(" + error + ")");
          window.alert(errMes.access);
          window.close();
        });
    },
    /**
     * Twitter投稿
     */
    async uploadTwitterImage({ state, commit }, { text }) {
      Logger.debug("[sns]act - uploadTwitterImage(" + text + ")");
      let sucMes = state.snsConfig.twitter.successMessage;
      let errMes = state.snsConfig.twitter.errorMessage;
      let postUrl =
        process.env.NODE_ENV === "development"
          ? "/sns/twitter/upload?from=web"
          : "/api/sns/twitter/upload?from=web";
      axios
        .post(postUrl, {
          headers: {
            "Access-Control-Allow-Origin": "*",
          },
          data: {
            token: twitJs.getTwitterAccess().acsToken,
            secret: twitJs.getTwitterAccess().acsTokenSecret,
            pic: twitJs.getTwitterCapture(),
            cross: twitJs.getTwitterCaptureCross(),
            graph: twitJs.getTwitterCaptureGraph(),
            text: text,
          },
        })
        .then((res) => {
          if (res.data.message != "Faild.") {
            commit("setTwitterLoading", false);
            setTimeout(() => {
              window.alert(sucMes);
              window.close();
            }, 300);
          } else {
            commit("setTwitterLoading", false);
            setTimeout(() => {
              window.alert(errMes.access);
              window.close();
            }, 300);
          }
          twitJs.resetTwitterStorage();
        })
        .catch((error) => {
          Logger.debug("[sns]act - uploadTwitterImage() error: " + error);
          commit("setTwitterLoading", false);
          setTimeout(() => {
            window.alert(errMes.access);
            window.close();
          }, 300);
        });
    },
    /**
     * Twitter投稿テキスト作成(観測所)
     */
    async getTextObs({ state }, { url, view, obsNm, rvrNm, rsysNm }) {
      Logger.debug("[sns]act - getTextObs()");
      let config = state.snsConfig.twitter;

      let textObs = config.obsFrame;
      if (rsysNm == null) {
        textObs = textObs
          .replace("*VIEW*", view != null ? view : "")
          .replace("*TMNAME*", obsNm != null ? obsNm : "")
          .replace("*RIVER*", rvrNm != null ? rvrNm : "")
          .replace("*RSYS*水系", "")
          .replace("*URL*", url != null ? url : "");
      } else {
        textObs = textObs
          .replace("*VIEW*", view != null ? view : "")
          .replace("*TMNAME*", obsNm != null ? obsNm : "")
          .replace("*RIVER*", rvrNm != null ? rvrNm : "")
          .replace("*RSYS*", rsysNm)
          .replace("*URL*", url != null ? url : "");
      }
      Logger.debug("[sns]act - getTextObs(" + textObs + ")");
      twitJs.setTwitterText(textObs);
    },
    /**
     * Twitter投稿テキスト作成(河川カメラ)
     */
    async getTextCam({ state }, { url, view, camNm, rvrNm, rsysNm, camUrl }) {
      Logger.debug("[sns]act - getTextCam()");
      let config = state.snsConfig.twitter;

      let textObs = config.obsFrame;
      if (rsysNm == null) {
        textObs = textObs
          .replace("*VIEW*", view != null ? view : "")
          .replace("*TMNAME*", camNm != null ? camNm : "")
          .replace("*RIVER*", rvrNm != null ? rvrNm : "")
          .replace("*RSYS*水系", "")
          .replace("*URL*", url != null ? url : "");
      } else {
        textObs = textObs
          .replace("*VIEW*", view != null ? view : "")
          .replace("*TMNAME*", camNm != null ? camNm : "")
          .replace("*RIVER*", rvrNm != null ? rvrNm : "")
          .replace("*RSYS*", rsysNm)
          .replace("*URL*", url != null ? url : "");
      }

      let textCam = config.camFrame;
      textCam = textCam.replace("*CAMURL*", camUrl);
      let shareText = textObs + textCam;
      Logger.debug("[sns]act - getTextCam(" + shareText + ")");
      twitJs.setTwitterText(shareText);
    },
    /**
     * Twitter投稿テキスト作成(レーダ)
     */
    async setTextRadar({ state }, { url, area }) {
      Logger.debug("[sns]act - setTextRadar(" + url + "," + area + ")");
      let config = state.snsConfig.twitter;

      let shareText = config.radarFrame;
      let text = shareText.replace("*AREA*", area).replace("*URL*", url);
      Logger.debug("[sns]act - setTextRadar(" + text + ")");
      twitJs.setTwitterText(text);
    },
    /**
     * Twitter画面キャプチャの取得
     */
    async getCapture({ state }, { type, imageTimeOut, mode }) {
      Logger.debug("[sns]act - getCapture(" + type + ")");
      let errMes = state.snsConfig.twitter.errorMessage;

      // セッションストレージをリセット
      twitJs.setTwitterCaptureCross(null);
      twitJs.setTwitterCaptureGraph(null);
      twitJs.setTwitterCapture(null);

      let contentWid = 200;
      let contentHght = 200;

      // シェアする画面によりキャプチャ取得範囲を設定
      let element = null;
      if (type == "detail") {
        element = document.body;
      } else if (type == "obs") {
        if (mode == "pc") {
          element = document.querySelector(".tm-pc-frame-content");
        } else if (mode == "mb") {
          element = document.querySelector("#tm-obs-dialog");
        }
      } else if (type == "radar") {
        element = document.body;
      }

      // 投稿コンテンツエリアの大きさを取得
      contentWid = element.clientWidth;
      contentHght = element.clientHeight;

      const options = {
        logging: false,
        useCORS: true,
        imageTimeout: imageTimeOut
      };

      // キャプチャを撮る
      if (element) {
        await html2canvas(element, options)
          .then((canvas) => {
            // キャプチャのアドレスを取得
            let base64 = canvas.toDataURL();

            let capture = {
              capData: base64,
              capSize: {
                width: contentWid,
                height: contentHght,
              },
              type: type,
            };
            twitJs.setTwitterCapture(capture);
          })
          .catch((error) => {
            Logger.debug("[sns]act - getCapture() error: " + error);
            window.alert(errMes.capture);
          });
      } else {
        window.alert(errMes.capture);
      }
    },
    /**
     * Twitter画面キャプチャの取得(水位詳細)
     */
    async getCaptureStageDetail({ state }, { imageTimeOut }) {
      Logger.debug("[sns]act - getCaptureStageDetail()");
      let errMes = state.snsConfig.twitter.errorMessage;

      // セッションストレージをリセット
      twitJs.setTwitterCaptureCross(null);
      twitJs.setTwitterCaptureGraph(null);
      twitJs.setTwitterCapture(null);

      // シェアする画面によりキャプチャ取得範囲を設定
      let elementCross = document.getElementById("content-stage-cross");
      let elementGraph = document.getElementById("content-stage-graph");

      const options = {
        logging: false,
        useCORS: true,
        imageTimeout: imageTimeOut
      };

      // キャプチャを撮る
      if (elementCross || elementGraph) {
        if (elementCross) {
          await html2canvas(elementCross, options)
            .then((canvasCross) => {
              // キャプチャのアドレスを取得
              let base64 = canvasCross.toDataURL();

              let captureCross = {
                capData: base64,
                capSize: {
                  width: elementCross.width,
                  height: elementCross.height,
                },
              };
              twitJs.setTwitterCaptureCross(captureCross);
            })
            .catch((error) => {
              Logger.debug(
                "[sns]act - getCaptureStageDetail() error: " + error
              );
              window.alert(errMes.capture);
            });
        }
        if (elementGraph) {
          await html2canvas(elementGraph, options)
            .then((canvasGraph) => {
              // キャプチャのアドレスを取得
              let base64 = canvasGraph.toDataURL();

              let captureGraph = {
                capData: base64,
                capSize: {
                  width: elementGraph.width,
                  height: elementGraph.height,
                },
              };
              twitJs.setTwitterCapture(null);
              twitJs.setTwitterCaptureGraph(captureGraph);
            })
            .catch((error) => {
              Logger.debug(
                "[sns]act - getCaptureStageDetail() error: " + error
              );
              window.alert(errMes.capture);
            });
        }
      }
    },
  }),
};
